// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-method-content {
	display: flex;
	flex-direction: column;
	margin: auto;
	text-align: center;
	width: 70%;
	transform: translateY(5%);
	margin-top: 10px;
	margin-bottom: 24px;
}

.payment-method-switch-label {
	width: 100%;
	background-color: rgba(0, 0, 0, 0.1);
	border-radius: 100px;
	position: relative;
	cursor: pointer;
	height: 43px;
}

.payment-method-toggle {
	position: absolute;
	width: 50%;
	background-color: #fff;
	box-shadow: 0 2px 15px rgba(0, 0, 0, 0.154);
	transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
	height: 43px;
	border-radius: 100px;
}

.paymnet-method-names {
	font-size: 90%;
	font-weight: 600;
	width: 70%;
	margin-left: 12.5%;
	margin-top: 10px;
	position: absolute;
	display: flex;
	justify-content: space-between;
	-webkit-user-select: none;
	        user-select: none;
}

.switched-to-cart {
	transform: translateX(100%);
	background-color: white;
}

.payment-bank-account-block {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.payment-bank-account-wrapper {
	width: 100%;
	padding: 0 8px;
}

.payment-card-block {
	display: flex;
	flex-direction: column;
}

.payment-method-requirement-block {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.payment-method-requirement-title {
	color: #4a4b65;
	font-weight: 600;
}

.payment-method-requirement-type {
	color: #4a4b65;
	font-weight: 500;
}

.nav-tabs .nav-item .active::before {
	content: unset !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/modals/AddPaymentMethod/AddPaymentMethod.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,oCAAoC;CACpC,oBAAoB;CACpB,kBAAkB;CAClB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,sBAAsB;CACtB,2CAA2C;CAC3C,+DAA+D;CAC/D,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,8BAA8B;CAC9B,yBAAiB;SAAjB,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;CAC3B,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B","sourcesContent":[".payment-method-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin: auto;\n\ttext-align: center;\n\twidth: 70%;\n\ttransform: translateY(5%);\n\tmargin-top: 10px;\n\tmargin-bottom: 24px;\n}\n\n.payment-method-switch-label {\n\twidth: 100%;\n\tbackground-color: rgba(0, 0, 0, 0.1);\n\tborder-radius: 100px;\n\tposition: relative;\n\tcursor: pointer;\n\theight: 43px;\n}\n\n.payment-method-toggle {\n\tposition: absolute;\n\twidth: 50%;\n\tbackground-color: #fff;\n\tbox-shadow: 0 2px 15px rgba(0, 0, 0, 0.154);\n\ttransition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n\theight: 43px;\n\tborder-radius: 100px;\n}\n\n.paymnet-method-names {\n\tfont-size: 90%;\n\tfont-weight: 600;\n\twidth: 70%;\n\tmargin-left: 12.5%;\n\tmargin-top: 10px;\n\tposition: absolute;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tuser-select: none;\n}\n\n.switched-to-cart {\n\ttransform: translateX(100%);\n\tbackground-color: white;\n}\n\n.payment-bank-account-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.payment-bank-account-wrapper {\n\twidth: 100%;\n\tpadding: 0 8px;\n}\n\n.payment-card-block {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.payment-method-requirement-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.payment-method-requirement-title {\n\tcolor: #4a4b65;\n\tfont-weight: 600;\n}\n\n.payment-method-requirement-type {\n\tcolor: #4a4b65;\n\tfont-weight: 500;\n}\n\n.nav-tabs .nav-item .active::before {\n\tcontent: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
